// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"4d7166c7","531":"0563b524","626":"4c68a991","739":"f2e16d89","762":"8672044f","904":"2ac73fa3"}[chunkId] + ".chunk.js";
};